<template>
  <QDialog
    v-model="dialogOpened"
    v-bind="$attrs"
    :allow-focus-outside="allowFocusOutside"
    class="streem-dialog"
    minimized
    :no-backdrop-dismiss="noBackdropDismiss"
    :no-esc-dismiss="noEscDismiss"
    @hide="$emit('hide')"
  >
    <div
      class="streem-dialog"
      :class="dialogClass"
      :style="dialogStyle"
    >
      <slot />
    </div>
  </QDialog>
</template>

<script>
export default {
  name: "CoreDialog",
  props: {
    modelValue: {
      type: Boolean,
    },
    noEscDismiss: {
      type: Boolean,
    },
    noBackdropDismiss: {
      type: Boolean,
    },
    dialogClass: {
      type: [Array, Object, String],
      default: () => [],
    },
    dialogStyle: {
      type: [Array, Object, String],
      default: () => [],
    },
    allowFocusOutside: {
      type: Boolean,
    },
  },
  emits: ["hide", "update:modelValue"],
  computed: {
    dialogOpened: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.streem-dialog {
  background-color: rgb(255 255 255);

  :deep(.bottom-bar) {
    margin-top: 20px;
    display: flex;

    .q-btn {
      flex: 1;
      box-shadow: none;

      &.valid {
        background-color: $primary;
        color: white;
      }
    }
  }

  .top-bar {
    margin: 0 -15px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid $silver-white;
  }
}

.mobile {
  .streem-dialog {
    :deep(.bottom-bar .q-btn) {
      padding: 15px 0;
    }
  }
}
</style>
